import { EasyEnvironment } from '@easy-lib/modules/shared/models/environment';
import { EnvType } from '@easy-lib/modules/shared/models';

const spaAppUrl = '';

export const envProdDefault: EasyEnvironment = {
	production: true,
	env: EnvType.PROD,
	appUrl: spaAppUrl,
	setting: {
		mtspath: 'https://api-mts.orbis.easytrader.ir/',
		lsUrl: 'https://ls.orbis.easytrader.ir',
		marketSheetLsUrl: ['https://ls-marketsheet1.orbis.easytrader.ir'],
		applogApiPath: 'https://stage-applogapi.easytrader.ir/api/',
		dataTracking: false,
		tradingViewStorageURL: 'https://api-mts.orbis.easytrader.ir/saveload',
		rocketChat: true,
		appSettingsUrl: 'https://api-mts.orbis.easytrader.ir/settings/',
		easy2ReferralUrl: 'https://d.easytrader.emofid.com'
	},
	sentry: {
		// dsn: 'https://81e2e944aea3427fbd3d051e84c2bec2@sapi.emofid.com/50',
		dsn: '',
		debug: false,
		environment: 'd-client.prod',
		maxBreadcrumbs: 100,
		attachStacktrace: true,
		tracesSampleRate: 1.0,
		breadcrumb: {
			console: false,
			sentry: false,
			dom: false,
			history: false,
			fetch: false,
			xhr: false
		},
		error: {
			error: true,
			unhandled: true
		}
	},
	unleash: {
		url: 'https://unleash-edge.orbis.easytrader.ir/api/frontend',
		appName: 'default',
		clientKey: 'default:production.0e68018c80f689af9e553daac3555bc646ddf639cf1774b8505dc4e2',
		refreshInterval: 0,
		environment: 'production'
	},
	postHog: {
		url: 'https://phog-api.emofid.com',
		token: 'phc_AFnureGmuRsrF10KMGzsgk2sAZIcCGduwuaiGW7X2Pr',
		active: false
	}
};
